
export default {
  UPDATE_VEHICLES ( state, vehicles){
    state.vehicles = vehicles
  },
  SET_CURRENT_PAGE(state, payload) {
    state.currentPage = payload
  }
}
